import { Serializable } from "../core";
import { Address, Product, Transaction } from "./index";
import { ProductAttribute } from "./product-attribute";

export type OrderState = "PENDING" | "PAID" | "POSTED" | "DELIVERED";

export class OrderItem implements Serializable<OrderItem> {
  id!: string;
  product!: Product;
  attribute!: ProductAttribute;
  count!: number;

  deserialize(json: any): OrderItem {
    this.id = json.id.toString();
    this.product = new Product().deserialize(json.product);
    this.attribute = new ProductAttribute().deserialize(json.attribute);
    this.count = json.count;
    return this;
  }
}

export class Order implements Serializable<Order> {
  id!: string;
  orderId!: string;
  state!: OrderState;
  user!: {
    firstName: string;
    sureName: string;
    phoneNumber: string;
    email?: string;
  };
  address!: Address;
  addressString!: string;
  items!: OrderItem[];
  transaction!: Transaction;
  date!: Date;
  postalTrackingCode!: string;
  isPackaged!: boolean;

  deserialize(json: any): Order {
    this.id = json.id;
    this.orderId = json.order_id;
    this.state = json.state as OrderState;
    this.user = {
      firstName: json.order_user.first_name,
      sureName: json.order_user.sur_name,
      phoneNumber: json.order_user.phone_number,
      ...(json.order_user.email === null
        ? { email: json.order_user.email }
        : {}),
    };
    this.address = new Address().deserialize(json.address);
    this.addressString = json.address_string;
    this.items = json.items.map((json: any) =>
      new OrderItem().deserialize(json)
    );
    if (json.transaction !== null)
      this.transaction = new Transaction().deserialize(json.transaction);
    this.date = new Date(json.date);
    this.postalTrackingCode = json.postal_tracking_code;
    this.isPackaged = json.is_packaged;
    return this;
  }
}
